import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { Spin, Tooltip } from "antd";
import { FaExclamationCircle } from "react-icons/fa";
import { FaRegCircleXmark, FaXmark, FaRegCircleCheck } from "react-icons/fa6";
import { RiExpandDiagonal2Line, RiCollapseDiagonal2Line } from "react-icons/ri";

import "./styles.scss"
import Preview from "./viewer";

const PDFPreview = ({ setShow, isDocDownload, goToPage, setGoToPage, restrictDownload }) => {
    const [fullScreen, setFullScreen] = useState(false)
    const [showDownloadSection, setShowDownloadSection] = useState(false);
    const [parentTagHeight, setParentTagHeight] = useState(0);
    
    const iframeRef = useRef()
    const pdfContentRef = useRef(null);
    const { data: s3Url, isLoading: s3UrlLoading, error: urlError, success: urlSuccess } = useSelector((state) => state?.s3urlRequest)
    const { data: signedURLResponse, isLoading: signedUrlLoading, error: signedUrlError, success: signedUrlSuccess } = useSelector((state) => state.chatSignedUrl)
    const { data: failedFile, isLoading: downloadFailedFileLoading, success: failedFailedSuccess, error: failedFailedError } = useSelector((state) => state.downloadFailedFile)      
    
    const handleClose = () => {
        setShow(false);
        // setGoToPage(0);
    }

    const handleResize = () => {
        setFullScreen(!fullScreen)
    }

    useEffect(() => {
        const parent = document.getElementsByClassName('pdf-preview-content');
        setParentTagHeight(parent[0]?.offsetHeight);
    }, [])

    useEffect(() => {
        if (showDownloadSection && signedUrlSuccess) {
            setTimeout(() => {
                setShowDownloadSection(false)
                setShow(false)
            }, 4000)
        }
    }, [showDownloadSection, signedUrlSuccess])

    useEffect(() => {
        if (isDocDownload) {
            setShowDownloadSection(true)
        }
    }, [isDocDownload])

    useEffect(() => {
        const iframe = iframeRef.current;
        if (iframe) { // Add null check here
            const pdfDoc = iframe.contentWindow.document;

            pdfDoc.addEventListener('load', () => {
                pdfContentRef.current = pdfDoc.body.innerHTML;
            });
        }
    }, [failedFile?.url?.url, s3Url?.url?.url, signedURLResponse?.url]);

    return (
        <>
            {(showDownloadSection) && (
                <div className="pdf-preview-download-section">
                    <div className="download-section-header">
                        <div className="header-title">Download Document</div>
                        <div className="header-icon" onClick={() => handleClose()}><FaXmark /></div>
                    </div>
                    <div className="download-section-body">
                        {signedUrlSuccess && (
                            <div className="download-message-container success-message">
                                <FaRegCircleCheck /> <div className="text">File Downloaded Successfully</div>
                            </div>
                        )}
                        {signedUrlError?.message && (
                            <div className="download-message-container error-message">
                                <FaExclamationCircle /> <div className="text">Failed to downloaded the document</div>
                            </div>
                        )}
                        {signedUrlLoading && (
                            <div className="file-loading-container">
                                <Spin size="large" />
                            </div>
                        )}
                        <div className="download-section-preview">
                            <iframe src={signedURLResponse?.url} height="10" width="10" title="Iframe Example" />
                        </div>
                    </div>
                </div>
            )}

            {!isDocDownload && (
                <div className={`pdf-preview-container ${fullScreen ? "full-width-container" : ""}`}>
                    <div className="pdf-preview-content">
                        <div className="icons-container">
                            <Tooltip>
                                <div className="resize-container" onClick={() => handleResize()}>
                                    {fullScreen ? (
                                        <RiCollapseDiagonal2Line />
                                    ) : (
                                        <RiExpandDiagonal2Line />
                                    )}
                                </div>
                            </Tooltip>
                            <div className="close-container">
                                Close <FaXmark className="close-icon" onClick={() => handleClose()} />
                            </div>
                        </div>

                        {/* Model 1 */}
                        {(failedFailedSuccess || urlSuccess || signedUrlSuccess) && (
                            // <iframe ref={iframeRef} src={s3Url?.url?.url || signedURLResponse?.url} className="doc-viewer" />
                            <Preview fileUrl={failedFile?.url?.url || s3Url?.url?.url || signedURLResponse?.url} fullScreen={fullScreen} parentHeight={parentTagHeight} goToPage={goToPage} 
                            // restrictDownload={restrictDownload} 
                            />
                        )}

                        {(downloadFailedFileLoading || s3UrlLoading || signedUrlLoading) && (
                            <div className="file-loading-container">
                                <Spin size="large" />
                            </div>
                        )}

                        {(failedFailedError?.message || urlError?.message || signedUrlError?.message) && (
                            <div className="file-error-container">
                                <FaRegCircleXmark className="x-mark-icon" />
                                {failedFailedError?.message || urlError?.message || signedUrlError?.message}
                            </div>
                        )}

                        {/* Model 2 */}
                        {/* <div className="preview-section">
                            <Worker workerUrl={`//unpkg.com/pdfjs-dist@4.4.168/legacy/build/pdf.worker.min.mjs`}>
                                <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                            </Worker>
                        </div> */}
                    </div >
                </div >
            )}
        </>
    )
}

export default PDFPreview
